export default {
  noActiveCalls: 'No active calls',
  noCalls: 'No results found.',
  currentCall: 'Current Call',
  ringCall: 'Ringing Call',
  onHoldCall: 'Call on Hold',
  historyCalls: 'Past Calls',
  otherDeviceCall: 'Ongoing calls on my other devices',
  searchPlaceholder: 'Search...',
} as const;
